import { z } from 'zod';
import { userRoleSchema } from '../../common/schemas/enum.schemas.js';
import { uuidSchema } from '../../common/schemas/id.schemas.js';
/** The trimmed user shape that travels with every token pair and `auth.me` response. */
export const userSummarySchema = z.object({
    id: uuidSchema,
    email: z.string().email(),
    name: z.string().min(1),
    role: userRoleSchema,
    /** True after an Administrator created or reset the account: the web sends the user to `/change-password` first. */
    mustChangePassword: z.boolean(),
});
export const loginInputSchema = z.object({
    email: z.string().min(1, 'Email is required').email('Enter a valid email address'),
    password: z.string().min(1, 'Password is required'),
});
export const refreshInputSchema = z.object({
    refreshToken: z.string().min(1, 'Refresh token is required'),
});
export const logoutInputSchema = refreshInputSchema;
export const logoutOutputSchema = z.object({
    success: z.literal(true),
});
export const PASSWORD_MIN_LENGTH = 10;
export const PASSWORD_MAX_LENGTH = 128;
/** The rule every new password follows; the current password is checked against its hash, not this. */
export const newPasswordSchema = z
    .string()
    .min(PASSWORD_MIN_LENGTH, `Use at least ${PASSWORD_MIN_LENGTH} characters`)
    .max(PASSWORD_MAX_LENGTH, `Use at most ${PASSWORD_MAX_LENGTH} characters`)
    .regex(/[A-Za-z]/, 'Include at least one letter')
    .regex(/\d/, 'Include at least one digit');
export const changePasswordInputSchema = z.object({
    currentPassword: z.string().min(1, 'Current password is required'),
    newPassword: newPasswordSchema,
});
export const tokensOutputSchema = z.object({
    accessToken: z.string().min(1),
    refreshToken: z.string().min(1),
    user: userSummarySchema,
});
//# sourceMappingURL=auth.schemas.js.map